import {
  Button,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import KontakDaruratModal from "./KontakDaruratModal";
import useFetchAllKontakDarurat from "../../../../api/effects/queries/KontakDarurat/useFetchAllKontakDarurat";
import { useRemoveKontakDarurat } from "../../../../api/effects/mutations/KontakDarurat/removeKontakDarurat";
import { RemoveModal } from "../../../../components/RemoveModal";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

export default function KontakDaruratTable() {
  const [editId, setEditId] = useState<number | null>(null);
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [removeModalText, setRemoveModalText] = useState("");

  const { data: kontakDaruratData } = useFetchAllKontakDarurat();

  const handleOpenRemoveModal = (text: string, id: number) => {
    setDeletingId(id);
    setRemoveModalText(`Remove ${text}?`);
  };

  const handleCloseRemoveModal = () => {
    setDeletingId(null);
  };

  const handleOpenEditModal = (id: number) => {
    setEditId(id);
  };

  const handleCloseEditModal = () => {
    setEditId(null);
  };

  const { mutateAsync: RemoveKontakDarurat } = useRemoveKontakDarurat({
    onSuccess() {
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const handleRemove = () => {
    if (deletingId !== null) {
      RemoveKontakDarurat(deletingId);
      handleCloseRemoveModal();
    }
  };

  return (
    <Grid container justifyContent="center">
      <KontakDaruratModal
        open={!!editId}
        handleClose={handleCloseEditModal}
        ID={editId || undefined}
      />
      <RemoveModal
        open={!!deletingId}
        handleClose={handleCloseRemoveModal}
        handleRemove={handleRemove}
        text={removeModalText}
      />
      <SquareGrid container>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Action</TableCell>
                <TableCell>Nama</TableCell>
                <TableCell>Hubungan</TableCell>
                <TableCell>Alamat</TableCell>
                <TableCell>Telepon</TableCell>
                <TableCell>Pekerjaan</TableCell>
                <TableCell align="center">Hapus</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {kontakDaruratData?.map((row) => (
                <TableRow
                  key={row.ID}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <Button
                      onClick={() => handleOpenEditModal(row.ID)}
                      disabled={!!deletingId || !!editId}
                    >
                      Ubah
                    </Button>
                  </TableCell>
                  <TableCell>{row.NAMA}</TableCell>
                  <TableCell>{row.HUBUNGAN}</TableCell>
                  <TableCell>{row.ALAMAT}</TableCell>
                  <TableCell>{row.TELEPON}</TableCell>
                  <TableCell>{row.PEKERJAAN}</TableCell>
                  <TableCell align="center">
                    <Button
                      color="error"
                      onClick={() => handleOpenRemoveModal(`${row.NAMA}`, row.ID)}
                      disabled={!!deletingId || !!editId}
                    >
                      Hapus
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography color="error">*Wajib Diisi dengan lengkap</Typography>
      </SquareGrid>
    </Grid>
  );
}